// extracted by mini-css-extract-plugin
export var chip = "_4e-0";
export var filterDropdown = "_4e-5";
export var filterItem = "_4e-6";
export var icon = "_4e-1";
export var removeButton = "_4e-3";
export var removeIcon = "_4e-4";
export var separator = "_4e-2";